import { z } from "zod/v4";

const envSchema = z.object({
  VITE_APP_NAME: z.string().default("Skul"),
  VITE_APP_ENV: z
    .enum(["development", "staging", "production"])
    .default("development"),
  VITE_API_BASE_URL: z.union([z.url(), z.string().startsWith("/")]),
  VITE_API_TIMEOUT: z.coerce.number().default(30000),
  VITE_WS_URL: z.string().optional(),
  VITE_SESSION_TIMEOUT: z.coerce.number().default(1800000),
  VITE_DEMO_MODE: z.enum(["true", "false", ""]).transform((v) => v === "true").default("false"),
  // Which strategy the login flow uses to resolve tenant_id before password
  // entry. "hardcoded" (DEMO_TENANT_ID) is also the automatic fail-safe
  // fallback within every other strategy if resolution fails — it is never
  // required to be selected as the primary strategy outside pre-production.
  VITE_TENANT_RESOLUTION: z
    .enum(["email-first", "subdomain", "field", "hardcoded"])
    .default("email-first"),
  VITE_FEATURE_MFA: z.enum(["true", "false", ""]).transform((v) => v !== "false").default("true"),
  VITE_FEATURE_OFFLINE: z.enum(["true", "false", ""]).transform((v) => v === "true").default("false"),
  VITE_FEATURE_MOBILE_MONEY: z.enum(["true", "false", ""]).transform((v) => v !== "false").default("true"),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_SENTRY_ENVIRONMENT: z.string().default("development"),
  VITE_DEFAULT_LOCALE: z.string().default("en"),
});

function validateEnv() {
  const result = envSchema.safeParse(import.meta.env);
  if (!result.success) {
    console.error(
      "Invalid environment variables:",
      result.error.format(),
    );
    throw new Error(
      "Invalid environment configuration. Check console for details.",
    );
  }
  return result.data;
}

export const env = validateEnv();
